import React from 'react'
import styled from 'styled-components'
import { colors, spacing, borderRadius, heading, mediaQuery } from 'src/constants/marketing-ds'
import { typographyMixin } from 'src/constants/marketing-ds'
import { getCardColor } from '../utils/colorMaps'

const ReasonCard = ({ card }) => {
  const IconComponent = card.icon

  return (
    <Card $hoverColor={card.hoverColor}>
      <CardGlow $color={card.color} />
      <CardContent>
        <CardIcon $color={card.color}>
          <IconComponent size={32} />
        </CardIcon>
        <CardTitle>{card.title}</CardTitle>
        <CardDescription dangerouslySetInnerHTML={{ __html: card.description }} />
        {card.realityLabel && (
          <CardReality>
            <RealityLabel $color={card.color}>{card.realityLabel}</RealityLabel>
            <RealityText>{card.realityText}</RealityText>
          </CardReality>
        )}
      </CardContent>
    </Card>
  )
}

export default ReasonCard

const Card = styled.div`
  background-color: rgb(30 41 59);
  border-radius: ${borderRadius.lg};
  padding: ${spacing.md};
  border: 1px solid ${colors.slate[30]};
  transition: all 0.3s;
  position: relative;
  display: flex;
  flex-direction: column;

  ${mediaQuery.tablet} {
    padding: ${spacing.sm};
  }
  ${mediaQuery.desktop} {
    padding: ${spacing.lg};
  }

  &:hover {
    border-color: ${(props) => getCardColor(props.$hoverColor, 'hover', colors.orange[90])};
  }
`

const CardGlow = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 128px;
  border-radius: 50%;
  filter: blur(48px);
  background-color: ${(props) => getCardColor(props.$color, 'glow', 'rgba(234, 88, 12, 0.05)')};
  transform: translateY(-50%) translateX(50%);
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 10;
`

const CardIcon = styled.div`
  width: 56px;
  height: 56px;
  background-color: ${(props) => getCardColor(props.$color, 'iconBg', 'rgba(234, 88, 12, 0.2)')};
  border-radius: ${borderRadius.md};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => getCardColor(props.$color, 'iconColor', colors.orange[90])};
  margin-bottom: ${spacing.md};
  transition: transform 0.3s;

  ${Card}:hover & {
    transform: scale(1.1);
  }
`

const CardTitle = styled.h3`
  color: ${colors.white};
  ${typographyMixin(heading.sm)}
  font-weight: 700;
  margin-bottom: ${spacing.xxs};
  ${mediaQuery.tablet} {
    margin-bottom: ${spacing.sm};
  }
`

const CardDescription = styled.p`
  color: ${colors.white};
  line-height: 1.6;
  margin-bottom: ${spacing.md};
  flex-grow: 1;
`

const CardReality = styled.div`
  padding-top: ${spacing.md};
  border-top: 1px solid rgba(148, 163, 184, 0.5);
`

const RealityLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => getCardColor(props.$color, 'label', '#fb923c')};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

const RealityText = styled.div`
  color: ${colors.white};
  font-weight: 500;
  margin-top: 4px;
`
